let baseThemeSettings = {
   palette: {
      type: 'dark',
      blueText: {
         main: '#0000ff',
      },
      text: {
         blueText: {
            main: '#0000ff',
         },
      },
      custom: {
         blueText: {
            main: '#0000ff',
         },
      },
      primary: {
         main: '#ffffff',
         light: '#5999ff',
         dark: '#ff0000',
      },
      darkText: {
         main: '#000000',
         light: '#000000',
         dark: '#000000',
      },
   },
   overrides: {
      palette: {
         coolText: {
            main: '0000ff',
         },
      },
   },
   typography: {
      fontFamily: '"Open Sans Condensed",sans-serif',
      button: {
         border: '2px solid white',
         backgroundColor: 'transparent',
      },
   },
};
export default baseThemeSettings;
